/** InsCoder 2025-02-27 B + Cust Video Slider Script **/

class CustVideoSlider {
  constructor(element) {
    this.section = element;
    this.slider = this.section.querySelector('.cust-video-slider-section-content');
    this.items = this.section.querySelectorAll('.cust-video-slider-section-content-item');
    
    if (!this.slider || this.items.length === 0) return;

    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.init();
  }

  init() {
    // Add cursor style for desktop interactivity
    // this.slider.style.cursor = 'grab';
    
    // Desktop Mouse Drag Events
    this.slider.addEventListener('mousedown', this.startDragging.bind(this));
    this.slider.addEventListener('mouseleave', this.stopDragging.bind(this));
    this.slider.addEventListener('mouseup', this.stopDragging.bind(this));
    this.slider.addEventListener('mousemove', this.move.bind(this));
    
    // Prevent default drag behavior on images/videos inside
    this.slider.querySelectorAll('img, video').forEach(el => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }

  startDragging(e) {
    this.isDown = true;
    this.slider.style.cursor = 'grabbing';
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
  }

  // stopDragging() {
  //   this.isDown = false;
  //   this.slider.style.cursor = 'grab';
  // }

  move(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 1.5; // Scroll speed multiplier
    this.slider.scrollLeft = this.scrollLeft - walk;
  }
}

// Initialize slider when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.cust-video-slider-section');
  sections.forEach(section => {
    new CustVideoSlider(section);
  });
});

/** InsCoder 2025-02-27 E + Cust Video Slider Script **/
